import React, { Component } from 'react';
import {
  compose,
} from 'recompose';
import { withRouter } from 'react-router';
import EmptyState from '../../Account/EmptyState';
import PropTypes from 'prop-types';
import { WithMethods } from '../../Common/Providers/CustomerVoucherApi';
import { VoucherCard } from './ViewComp';
import { connectUserDetail } from '../../Auth/UserDetailManager';
import Pagination from '../../Common/Pagination';
import SearchSpinner from '../../Common/SpinnerWithoutOverlay';
import {
  withExtendVoucherState,
  withOnClickToExtendVoucher,
  withExtendVoucherModal
} from './withExtendVoucher';
import { withVouchersData } from './withVouchersData';
import { withVoucherExtendInfo } from './withVoucherExtendInfo';
import { withModal } from '../../Common/Modal/Modal';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import { showPermanentErrorMsg } from '../../Common/ErrorMsg';
import { withStartProjectState } from './withStartProject';
import VoucherActivationForm from './VoucherActivationForm'
import config from '../../../config';

export const withExtendVoucher = compose(
  withExtendVoucherState,
  withOnClickToExtendVoucher,
  withExtendVoucherModal,
  withModal,
);

class Voucher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false
    };

    this.getData = this.getData.bind(this);
    this.extendVoucher = this.extendVoucher.bind(this);
    this.getApplicableProducts = this.getApplicableProducts.bind(this);
    this.handleCategoryOrEditorRedirect = this.handleCategoryOrEditorRedirect.bind(this);

    this.shouldCallApi = window.location.pathname.includes('voucher');
    this.didCallApi = false;
    this.voucherRefs = {};
    this.buttonRefs = {};
  }

  componentDidUpdate() {
    const queryParams = new URLSearchParams(window.location.search);
    const voucherCode = queryParams.get('code');

    this.shouldCallApi = window.location.pathname.includes('voucher');
    if(this.shouldCallApi && !this.didCallApi) {
      this.didCallApi = true;

      this.props.index({ status: this.props.currentStatus, code: voucherCode }).done((response) => {
        this.props.updateVouchersData(true, response.data);
        if (voucherCode) {
          if (this.voucherRefs[voucherCode]) {  
            this.voucherRefs[voucherCode].scrollIntoView({ behavior: 'smooth',  block: 'center' });
            setTimeout(() => {
              this.buttonRefs[voucherCode].click();
            }, 500);
          } else {
            this.props.router.push('/expired-voucher');
          }
        }
      }).fail(response => alert(`${this.props.t("account.voucher_fail_alert", "Get voucher failed")} ${response.status}`));
    }


  }

  getData(pageNum, currentStatus = this.props.currentStatus) {
    this.props.updateVouchersData(false);

    this.props
      .index({
        page: pageNum,
        status: currentStatus,
      })
      .done((response) => {
        this.props.updateVouchersData(true, response.data, pageNum, currentStatus);
      })
      .fail(response => alert(`${this.props.t('account.voucher_fail_alert', 'Get voucher failed')} ${response.status}`));
  }

  toggleDrawer = () => {
    this.setState(prevState => ({
      isDrawerOpen: !prevState.isDrawerOpen
    }));
  }

  extendVoucher(voucherCode, extendDate) {
    this.props.updateVoucherExtendInfo(voucherCode, extendDate);
    this.props.openModal();
  }

  getApplicableProducts(voucherCode) {
    return this.props
      .getVoucherProducts(voucherCode)
      .fail(() => {
        showPermanentErrorMsg('Error: Voucher is no longer available');
      });
  }

  handleCategoryOrEditorRedirect(voucherCode, path, attributes = {}, page_from=null, is_photobook, is_epic_photobook) {
    const {
      router,
      saveVoucherCode,
      saveProductAttributes,
    } = this.props;

    saveVoucherCode(voucherCode);
    saveProductAttributes(attributes);

    const queryParams = Object.keys(attributes)
      .map(key => `${key}=${attributes[key]}`);

    const searchParams = queryParams.join('&');
    const pageFromParam = page_from ? `&page_from=${page_from}` : '';
    
    router.push({
      pathname: this.props.tRoute(path),
      search: is_photobook 
        ? encodeURI(`/smart-wizard?${searchParams}&productId=blank-photobook`) 
        : is_epic_photobook 
          ? encodeURI(`/editor?${searchParams}&productId=blank-epic-photobook`) 
          : encodeURI(`?${searchParams}${pageFromParam}`),
    });
  }

  onClickStatus(status) {
    if (this.props.currentStatus !== status) {
      this.getData(1, status);
    }
  }

  render() {
    if (!this.props.isLoaded) {
      return (
        <div className='dashboard-card p-3 p-lg-5'>
          <SearchSpinner/>
        </div>
      );
    }

    const {
      currentStatus = 1,
      vouchersData: {
        total,
        valid_total = 0,
        invalid_total = 0,
        last_page,
        current_page,
        per_page,
        items,
      },
      tRoute,
    } = this.props;

    const StatusBar = () => {
      const activeBtnClass = (currentStatus === 1)
        ? 'btn btn-primary'
        : 'btn btn-outline-primary';
      const inactiveBtnClass = (currentStatus === 0)
        ? 'btn btn-primary'
        : 'btn btn-outline-primary';
      const activeText = <HTMLTrans id='account.btn_valid_filter'>ACTIVE</HTMLTrans>;
      const inactiveText = <HTMLTrans id='account.btn_invalid_filter'>USED/EXPIRED</HTMLTrans>;

      return (
        <div>
          <div className='col-lg-6 col-sm-12 p-0'>
            <div className='btn-group btn-group-sm d-flex' role='group'>
              <button type='button' className={`${activeBtnClass} w-100`}
                      onClick={this.onClickStatus.bind(this, 1)}>{activeText} {valid_total > 0 && `(${valid_total})`}</button>
              <button type='button' className={`${inactiveBtnClass} w-100`}
                      onClick={this.onClickStatus.bind(this, 0)}>{inactiveText}</button>
            </div>
          </div>
        </div>
      );
    };

    const VoucherItems = () => (
      <div className='voucher'>
        {items.map((item, index) => (
          <VoucherCard
            innerRef={(ref) => (this.voucherRefs[item.voucher_code] = ref)}
            buttonRef={(ref) => (this.buttonRefs[item.voucher_code] = ref)}
            key={index}
            name={item.name}
            description={item.description}
            price={item.is_gift_card ? `${item.currency}${item.gift_card_value}` : `${item.currency}${item.purchased_price}`}
            type={`${item.type}`}
            status={item.status}
            expiryDate={item.expiry_date}
            voucherCode={item.voucher_code}
            displayOptions={item.display_options}
            onClick={this.extendVoucher.bind(this, item.voucher_code, item.max_extend_expiry_date)}
            getApplicableProducts={this.getApplicableProducts.bind(this, item.voucher_code)}
            handleCategoryOrEditorRedirect={this.handleCategoryOrEditorRedirect.bind(this, item.voucher_code)}
            currentStatus={currentStatus}
            promotionPlatforms={item.promotion_platforms}
            isGiftCard={item.is_gift_card}
          />
        ))}
      </div>
    );

    const SideDrawer = ({ isOpen, onClose }) => {
      return (
      <div className={`side-drawer ${isOpen ? 'open' : ''}`}>
        <div className='side-drawer-content'>
          <div className='d-flex justify-content-end'>
            <button className='close-drawer' onClick={onClose}>
              <img src={`${config.s3BucketUrl}/assets/email/icons/prp_close.png`} width='17' alt='Close Icon' />
            </button>
          </div>
          <div>
            <h3 className='mt-4 mb-5'><HTMLTrans id='account.how_to_redeem_title'>How to redeem my prepaid vouchers?</HTMLTrans></h3>
              <div className='mb-5'>
                <h5 className='ProximaNova-Bold option-text'><HTMLTrans id="account.option_a">Option A - Starting a New Project</HTMLTrans></h5>
                <div className='option-steps'>
                  <p>
                    <HTMLTrans id="account.option_a_step_1">
                      Step 1: At "My Vouchers", click on "Start Project" for any active prepaid voucher.
                    </HTMLTrans>
                  </p>
                  <p>
                    <HTMLTrans id="account.option_a_step_2">
                      Step 2: Complete your project and add it to the cart.
                    </HTMLTrans>
                  </p>
                  <p>
                    <HTMLTrans id="account.option_a_step_3">
                      Step 3: Your prepaid voucher will be automatically applied to your project.
                    </HTMLTrans>
                  </p>
                </div>
              </div>
              <div className='mb-5'>
                <h5 className='ProximaNova-Bold option-text'><HTMLTrans id="account.option_b">Option B - Applying a prepaid voucher to an existing project</HTMLTrans></h5>
                <div className='option-steps'>
                  <p>
                    <HTMLTrans id="account.option_b_step_1">
                      Step 1: Finish your ongoing project and add it to the cart.
                    </HTMLTrans>
                  </p>
                  <p>
                    <HTMLTrans id="account.option_b_step_2">
                      Step 2: Copy an active prepaid voucher code from "My Vouchers" or your prepaid voucher confirmation email.
                    </HTMLTrans>
                 </p>
                  <p>
                    <HTMLTrans id="account.option_b_step_3">
                      Step 3: In the cart, locate the voucher code redemption field at the bottom.
                    </HTMLTrans>
                  </p>
                  <p>
                    <HTMLTrans id="account.option_b_step_4">
                      Step 4: Paste the prepaid voucher code and apply.
                    </HTMLTrans>
                  </p>
                  <p>
                    <HTMLTrans id="account.option_b_step_5">
                      Step 5: Choose the specific project to which you want to apply the prepaid voucher.
                    </HTMLTrans>
                  </p>
                </div>
              </div>
            <p>
              <HTMLTrans id="account.drawer_help_text">If you have any questions or need assistance with the redemption process, please don't hesitate to contact our friendly customer support team <a href='/support/contact'>here</a>'.</HTMLTrans>
            </p>
          </div>
        </div>
      </div>
      );
    };

    const EmptyVoucherItems = () => (
      <div className='mt-4'>
        {
          currentStatus === 1
            ? <p><HTMLTrans id='account.empty_valid_voucher'>You don't have any active
              vouchers.</HTMLTrans></p>
            :
            <p><HTMLTrans id='account.empty_invalid_voucher'>You don't have any used /
              expired vouchers.</HTMLTrans></p>
        }
      </div>
    );

    if (!valid_total && !invalid_total) {
      const data = {
        heading: <HTMLTrans id="account.voucher_empty_data_heading">My Vouchers</HTMLTrans>,
        body: {
          header: <div>
            <p className='h4'>
              <HTMLTrans id="account.voucher_empty_data_body">You haven't bought any vouchers yet. Go to our promotion page to see our latest promotions. OR </HTMLTrans>
            </p>
            <p className='h4'>
              <HTMLTrans id="account.voucher_activation_form_description">Activate voucher here for safe keeping and reminder.</HTMLTrans>
            </p>
            <VoucherActivationForm
              {...this.props}
              getData={this.getData}
            />
          </div>,
        },
        ctaButtons: [
          {
            type: 'outline', refresh: true, label: <HTMLTrans id="account.voucher_empty_data_button">See Our Promo</HTMLTrans>, url: tRoute('/promotions'),
          },
        ],
      };

      const emptyStateComp = <div>
        <EmptyState
          data={data}
        >
          <VoucherActivationForm
            {...this.props}
            getData={this.getData}
          />
        </EmptyState>
      </div>

      return emptyStateComp;
    }

    return (
      <div>
        <div className='dashboard-card p-3 p-lg-5'>
          <h3><HTMLTrans id="account.voucher_title">My Vouchers</HTMLTrans></h3>
          <hr />
          <div className='col-lg-12 p-0'>
            <div className='voucher-activation-section'>
              <p>
                <span className='ProximaNova'>
                  <HTMLTrans id="account.voucher_activation_form_description">Activate voucher here for safe keeping and reminder.</HTMLTrans>
                </span>
              </p>
              <VoucherActivationForm
                {...this.props}
                getData={this.getData}
              />
            </div>
          </div>
          <hr />
          <StatusBar/>
          <div className='mt-4'>
            <p className='text-primary ProximaNova-Regular cursor-pointer my-2' onClick={this.toggleDrawer}>
              <HTMLTrans id="account.how_to_redeem_my_prepaid_vouchers">
                How to redeem my prepaid vouchers?
              </HTMLTrans>
            </p>
            <div className={`overlay ${this.state.isDrawerOpen ? 'open' : ''}`} onClick={this.toggleDrawer}></div>
          </div>
          {items.length > 0 ? <VoucherItems/> : <EmptyVoucherItems/>}
          <Pagination
            lastPageNumber={last_page}
            currentPageNumber={current_page}
            onClick={this.getData}
          />
          <SideDrawer 
            isOpen={this.state.isDrawerOpen} 
            onClose={() => this.setState({ isDrawerOpen: false })} 
          />
        </div>
      </div>
    );
  }
}

Voucher.propTypes = {
  index: PropTypes.func.isRequired,
  updateVouchersData: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  vouchersData: PropTypes.object,
  updateVoucherExtendInfo: PropTypes.func.isRequired,
  currentStatus: PropTypes.number,
  saveVoucherCode: PropTypes.func.isRequired,
  saveProductAttributes: PropTypes.func.isRequired,
  startProjectProductAttributes: PropTypes.object.isRequired,
};

export default compose(
  connectUserDetail,
  withVouchersData,
  WithMethods,
  withVoucherExtendInfo,
  withExtendVoucher,
  withRouter,
  withTranslationProvider,
  withStartProjectState,
)(Voucher);

export const undecorated = Voucher;



// WEBPACK FOOTER //
// ./src/Account/Voucher/Voucher.js